import React, { useEffect, useState } from "react";
import "./AutoNurtureMemory.css";
import {
  listMemories,
} from "../../../services/iqApiV2";
import { useUser } from "../../../context/UserContext";
import SimpleThemedButton from "../../Frontend/genericComponents/simpleTextField/SimpleThemedButton";
import AutoNurtureEmailCard from "./AutoNurtureEmailCard";

const generateNewTimestampId = () =>
  `new_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

function AutoNurtureMemory() {
  const { user } = useUser();
  const [emails, setEmails] = useState([]);
  const [saving, setSaving] = useState(false);

  // Fetch saved memories
  useEffect(() => {
    async function fetchData() {
      try {
        const resp = await listMemories(user?.id, "email_nurture");
        setEmails(resp || []);
      } catch (err) {
        console.error("Error fetching memories:", err);
      }
    }
    fetchData();
  }, [user?.id]);

  const handleAddNew = () => {
    const newEmail = {
      id: generateNewTimestampId(),
      prompt: "",
      created_at: new Date().toISOString(),
      isDraft: true,
    };
    setEmails((prev) => [newEmail, ...prev]);
  };

  return (
    <div className="anm-wrapper">
      <div className="anm-topbar">
        <h3>&nbsp;&nbsp;Auto Nurture Memory</h3>
        <SimpleThemedButton
          btnDisabled={saving}
          buttonText="Add Email To Memory"
          isLoading={saving}
          loaderTxt="Saving"
          onBtnClick={handleAddNew}
        />
      </div>

      <div className="anm-list">
        {emails.length === 0 && (
          <p className="anm-empty">
            No nurture emails yet. Click “Add Email To Memory” to start.
          </p>
        )}

        {emails.map((email) => (
          <AutoNurtureEmailCard
            key={email.id}
            email={email}
            user={user}
            handleAfterSave={(emailId, updatedPrompt) => {
              setEmails((prev) =>
                prev.map((item) =>
                  item.id === emailId
                    ? { ...item, isDraft: false, prompt: updatedPrompt }
                    : item
                )
              );
            }}
            handleAfterDelete={(emailId) => {
              setEmails((prev) => prev.filter((e) => e.id !== emailId));
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default AutoNurtureMemory;
